import styled from 'styled-components';
import { DividerProps } from '.';

export const Wrapper = styled.div<DividerProps>`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.bg800};
  margin: ${({ my }) => my}px 0;
`;
